import React from 'react';
const IconNavVersionsFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="6" width="16" height="2" fill="#2D2E2E"/>
<rect x="5" y="2" width="14" height="2" fill="#2D2E2E"/>
<rect x="3" y="10" width="18" height="12" fill="#2D2E2E" />
</svg>
);
};
export default IconNavVersionsFill;